<template>
    <div class="tiku-detail common-detail">
        <div class="tiku-detail-banner">
            <div class="banner-content">
                <div class="left">
                    <!-- <div>乐分享题库系统 · <span>网页版</span></div>
                    <div></div>
                    <div>分享题目有收益<br>基础题库免费送<br>私有题库、共享题库、多人协作<br>针对大团队提供独立私密云空间<br>完美兼容Word的全部格式<br>完美支持公式、图形、图片、符号……<br>集批量上传、编辑、组卷、考试、成绩分析等所有功能于一身</div> -->
                    <div class="btns">
                        <div @click="toTry">立即试用</div>
                        <div @click="handle">视频教程</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="item1">
            <div class="item1-header">
                <div class="title">乐分享题库系统 · 网页版</div>
                <div class="sub-title">适用于所有行业、全部学科快速建立专业题库！</div>
            </div>
            <div class="item1-wrapper">
                <div class="card" id="card1" :class="animateObj['#card1'] ? 'ani' : ''">
                    <div>快速建立题库</div>
                    <div>最快一小时可以批量入库3000~7000题（格式规范、操作熟练后）</div>
                </div>
                <div class="card" id="card5" :class="animateObj['#card5'] ? 'ani' : ''">
                    <div>试题篮</div>
                    <div>用于暂存在题目浏览页面加入到试题篮中的题目和应用中心智能组卷选出的题目。</div>
                </div>
                <div class="card" id="card3" :class="animateObj['#card3'] ? 'ani' : ''">
                    <div>题目私有化</div>
                    <div>方便创建独家试题、题目更加私密</div>
                </div>
                <div class="card" id="card6" :class="animateObj['#card6'] ? 'ani' : ''">
                    <div>个性定制</div>
                    <div>根据不同行业、人群定制不同功能</div>
                </div>
                <div class="card" id="card2" :class="animateObj['#card2'] ? 'ani' : ''">
                    <div>全兼容Word</div>
                    <div>支持Word所支持的全部格式。独创把 Word嵌入到软件中的功能，在软件中 直接使用Word编辑题目。</div>
                </div>
                <div class="card" id="card4" :class="animateObj['#card4'] ? 'ani' : ''">
                    <div>试题的管理</div>
                    <div>可以根据浏览需求，快速对试题进行修改设置， 编辑题目入库。</div>
                </div>
            </div>
        </div>
        <div class="item2">
            <div class="item2-wrapper">
                <div class="item2-title">产品优势</div>
                <ul class="list">
                    <li v-for="(item,index) in youshi" :key="index" :id="'item' + (index + 1)" :class="animateObj['#item' + (index + 1)] ? 'ani' : ''">
                        <div>{{item.title}}</div>
                        <div>{{item.intro}}</div>
                    </li>
                </ul>
            </div>
        </div>
        <div class="item3">
            <div class="title">特别功能</div>
            <ul>
                <li :class="activeIndex === index ? 'active' : ''" @click="turn(index)" v-for="(item,index) in spacialArr" :key="index">
                    <div class="first">
                        <div :title="item">{{item}}</div>
                    </div>
                </li>
            </ul>
            <div class="item3-content">
                <div class="main">
                    <div class="left">
                        <div style="margin-top:50px">{{spacialArr[activeIndex]}}</div>
                        <div v-html="introArr[activeIndex].intro"></div>
                        <div class="btn" style="margin-top:25px">
                            <el-button type="warning" @click="toTry">点击试用</el-button>
                        </div>
                    </div>
                    <div class="right">
                        <img :src="introArr[activeIndex].img" alt="" @click="zoomIn(introArr[activeIndex].img)">
                    </div>
                </div>
            </div>
        </div>
        <div class="item6">
            <div class="item6-wrapper">
                <div class="item6-title"><span>网页版</span> VS 客户端</div>
                <div class="item6-subtitle">适用于所有行业、全部学科快速建立专业题库</div>
                <div class="list-wrapper">
                    <div id="item6-list1" :class="animateObj['#item6-list1'] ? 'ani' : ''">
                        <div class="list-title">网页版优势</div>
                        <ul>
                            <li>最快一小时可以批量入库2000~3000题</li>
                            <li>提供模板对试卷进行优化处理确保快速简洁</li>
                            <li>批量入库前会智能识别题型、题目和答案，自动检查题目和答案的对应关系。</li>
                            <li>入库时可以指定信息，自动检测重题，自动归集题目。</li>
                        </ul>
                    </div>
                    <div id="item6-list" :class="animateObj['#item6-list'] ? 'ani' : ''">
                        <div class="list-title">客户端优势</div>
                        
                        <ul>
                            <li>格式规范，操作熟练后，一天入库数量可达3000-7000题</li>
                            <li>提供三个入库模板，分别对应不同类型的试卷进行处理和优化.</li>
                            <li>入库前会智能识别题目、题型和答案，自动检查题目和答案对应关系</li>
                            <li>入库时可重题检测，确保没有相同试题造成混乱</li>
                            <li>入库时可以指定章节、知识点、难度、来源分值等题目信息，无需入库后在进行操作</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div class="item4">
            <div class="item4-wrapper">
                <div class="title">观看<span>使用帮助</span>，快速了解本产品操作方法</div>
                <div class="sub-title">根据功能页面分别介绍产品的使用方法，简单易懂，操作方便</div>
                <div class="item4-content">
                    <div class="line">
                        <ul class="line-list">
                            <li>
                                <div class="block">
                                    <div>试题批量入库</div>
                                    <div>
                                        <img @click="toLook('上传题目.mp4')" :src="sc" alt="">
                                    </div>
                                    <div class="shuxian"></div>
                                </div>
                            </li>
                            <li>
                                <div class="style2">
                                    <div class="shuxian"></div>
                                    <div>
                                        <img @click="toLook('手工组卷.mp4')" :src="gl" alt="">
                                    </div>
                                    <div>手工组卷</div>
                                </div>
                            </li>
                            <li>
                                <div class="block">
                                    <div>智能组卷</div>
                                    <div>
                                        <img @click="toLook('智能组卷.mp4')" :src="zj" alt="">
                                    </div>
                                    <div class="shuxian"></div>
                                </div>
                            </li>
                            <li>
                                <div class="style2 ctb">
                                    <div class="shuxian"></div>
                                    <div>
                                        <img @click="toLook('编辑题目.mp4')" :src="ctb" alt="">
                                    </div>
                                    <div>编辑题目</div>
                                </div>
                            </li>
                            <li>
                                <div class="block">
                                    <div>考试管理</div>
                                    <div>
                                        <img @click="toLook('考试管理.mp4')" :src="sg" alt="">
                                    </div>
                                    <div class="shuxian"></div>
                                </div>
                            </li>
                            <li>
                                <div class="style2">
                                    <div class="shuxian"></div>
                                    <div>
                                        <img @click="toLook('下载试卷.mp4')" :src="xz" alt="">
                                    </div>
                                    <div>下载试卷</div>
                                </div>
                            </li>
                            <li>
                                <div class="block sjk">
                                    <div>发布考试</div>
                                    <div>
                                        <img @click="toLook('发布考试.mp4')" :src="sjk" alt="">
                                    </div>
                                    <div class="shuxian"></div>
                                </div>
                            </li>
                            <li></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        
        <div class="video-wrapper" v-if="showVideo">
            <div class="video-content">
                <div class="close"><i class="el-icon-error" @click="close"></i></div>
                <video-player  class="video-player vjs-custom-skin"
                    ref="videoPlayer"
                    :playsinline="true"
                    :options="playerOptions"
                ></video-player>
            </div>
        </div>
        <transition name="fade">
            <div class="mask" v-show="preShow" @click="zoomOut">
                <div class="img-main">
                    <img :src="preImg" alt="">
                </div>
            </div>
        </transition>
    </div>
</template>
<script>
import { videoPlayer } from 'vue-video-player'
import 'video.js/dist/video-js.css'
export default {
    data(){
        return {
            preImg: '',
            preShow: false,
            path: process.env.BASE_URL,
            hezuo: [
                {
                    img: require('@/assets/hezuo/hebei.jpeg'),
                    name: '河北师范大学'
                }
            ],
            img2: require('@/assets/img_3.png'),
            sc: require('@/assets/icon_sc.png'),
            gl: require('@/assets/icon_gl.png'),
            ctb: require('@/assets/icon_ctb.png'),
            sg: require('@/assets/icon_sg.png'),
            xz: require('@/assets/cion_xz.png'),
            sjk: require('@/assets/icon_sjk.png'),
            zj: require('@/assets/icon_zj.png'),
            showVideo: false,
            playerOptions : {
                playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
                autoplay: true, //如果true,浏览器准备好时开始回放。
                muted: false, // 默认情况下将会消除任何音频。
                loop: false, // 导致视频一结束就重新开始。
                preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
                language: 'zh-CN',
                aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
                fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
                sources: [{
                src: `${process.env.BASE_URL}video/demo.mp4`,  // 路径
                type: 'video/mp4'  // 类型
                }],
                // poster: require('@/assets/logo.png'), //你的封面地址
                // width: document.documentElement.clientWidth,
                notSupportedMessage: '此视频暂无法播放，请稍后再试', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
                controlBar: {
                timeDivider: true,
                durationDisplay: true,
                remainingTimeDisplay: false,
                fullscreenToggle: true  //全屏按钮
                }
            },
            youshi: [
                {
                    title: '批量入库',
                    intro: '格式规范，操作熟练后，一天入库数量可达3000-7000题'
                },
                {
                    title: '编辑题目',
                    intro: '个人版支持批量上传修改题目等功能，功能更强大'
                },
                {
                    title: '智能识别',
                    intro: '批量入库前会智能识别题型、题目和答案，自动检查题目和答案的对应关系，确保快速，准确！'
                },
                {
                    title: '题目私有化',
                    intro: '对于独家的一手题目，入库时可设置成私有的，非常贴心'
                },
                {
                    title: '检测重题',
                    intro: '入库时自动检测重题，对于重题会自动提示，并且显示重题的内容，方便快速校对。'
                },
                {
                    title: '归类',
                    intro: '入库时自动把题目相应属性（章节、 知识点、题型、难度等）归集到相应 题目下，真正的智能题库软件！'
                },
            ],
            spacialArr: ['快速入库','全兼容word','组卷多样化','快速建立错题本','题目私有化','试卷预览','生成试卷','考试管理','成绩管理','团队协作','个性定制','精品题目资源','……'],
            introArr: [
                {
                    intro: '智能识别题型题目答案解析<br>一键批量入库、入库后自动分类<br>重题检测',
                    img: require('@/assets/tiku1.png')
                },
                {
                    intro: '支持所有公式、图片、学科等符号<br>入库后公式导出后仍可编辑<br>确保出库入库所有公式原汁原味，专业性强',
                    img: require('@/assets/tiku2.png')
                },
                {
                    intro: '手工组卷和智能组卷随心选择<br>试题结构随易调整更方便<br>一键生成试题',
                    img: require('@/assets/tiku3.png')
                },
                {
                    intro: '自动生成错题集（针对错题练习，方便查缺补漏）<br>错题集支持下载打印（方便保存、共享难题，错题）',
                    img: ''
                },
                {
                    intro: '方便创建独家试题<br>题目更加私密',
                    img: require('@/assets/tiku4.png')
                },
                {
                    intro: '方便下载、保存试卷等<br>随意调整试卷结构<br>题目信息位置等不对可随时调整',
                    img: require('@/assets/tiku5.png')
                },
                {
                    intro: '一键发布试卷<br>一键查看试卷内容',
                    img: require('@/assets/tiku6.png')
                },
                {
                    intro: '自动根据学科，年级等分类<br>随时修改考试信息',
                    img: require('@/assets/tiku7.png')
                },
                {
                    intro: '根据考试或考生自动分类，轻便简洁<br>一键导出考试成绩',
                    img: require('@/assets/tiku8.png')
                },
                {
                    intro: '不同成员分配不同权限，互不干扰<br>题库设置全局，机构内人员都可使用',
                    img: require('@/assets/tiku9.png')
                },
                {
                    intro: '根据不同行业、人群定制不同功能',
                    img: ''
                },
                {
                    intro: '帮助用户快速搭建自己的题库<br>不定时更新新的资源',
                    img: require('@/assets/tiku10.png')
                },
            ],
            activeIndex: 0,
            animateObj: {
                '#card1': false,
                '#card2': false,
                '#card3': false,
                '#card4': false,
                '#card5': false,
                '#card6': false,
                '#item1': false,
                '#item2': false,
                '#item3': false,
                '#item4': false,
                '#item5': false,
                '#item6': false,
                '#item6-list': false,
                '#item6-list1': false,
            }
        }
    },
    components: {
        videoPlayer
    },
    methods: {
        // 点击图片放大
        zoomIn(src){
            this.preImg = src;
            this.preShow = true;
        },
        // 点击图片缩小
        zoomOut(){
            this.preShow = false;
        },
        toTry(){
            window.open(IPConfig.tikuUrl);
        },
        handle(){
            this.playerOptions.sources = [{
                src: `${this.path}video/productIntro/cloud.mp4`,  // 路径
                type: 'video/mp4'  // 类型
            }];
            this.showVideo = true;
        },
        toLook(url){
            this.playerOptions.sources = [{
                src: `${this.path}video/tiku/${url}`,  // 路径
                type: 'video/mp4'  // 类型
            }];
            this.showVideo = true;
        },
        close(){
            this.showVideo = false;
        },
        turn(index){
            if(index !== this.spacialArr.length - 1){
                this.activeIndex = index;
            }
        },
        handleScroll () {
            this.preShow = false;
            // var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
            var w = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
            for(var key in this.animateObj){
                var offsetTop = document.querySelector(key).getBoundingClientRect().top;
                if(offsetTop < w){
                    this.animateObj[key] = true;
                }else{
                    this.animateObj[key] = false;
                }
            }
        },
    },
    destroyed(){
        window.removeEventListener('scroll', this.handleScroll);
    },
    mounted(){
        window.addEventListener('scroll', this.handleScroll);
        this.handleScroll();
    }
}
</script>
<style lang="less">
    @import './css/product.less';
    .tiku-detail{
        .ani{
            transform: translateZ(0)!important;
            opacity: 1!important;
        }
        .tiku-detail-banner{
            height: 730px;
            background: #198AF7 url('../assets/home_2.png') no-repeat center center;
            background-size: auto 100%;
            .banner-content{
                .left{
                    right: 0;
                }
            }
        }
        
        .item6{
            background: url('../assets/img_lr.png') no-repeat center center;
            height: 750px;
            .item6-wrapper{
                width: 1200px;
                margin: 0 auto;
                padding: 70px 0;
                .item6-title{
                    font-size: 36px;
                    text-align: center;
                    color: #fff;
                    span{
                        color: #FFC446;
                    }
                }
                .item6-subtitle{
                    text-align: center;
                    color: #C9E9FF;
                    font-size: 18px;
                }
                .list-wrapper{
                    display: flex;
                    justify-content: space-around;
                    margin-top: 60px;
                    >div{
                        width:332px;
                        height:468px;
                        background:rgba(255,255,255,1);
                        box-shadow:0px 0px 18px 0px rgba(3, 136, 83, 0.35);
                        border-radius:8px;
                        box-sizing: border-box;
                        padding: 30px;
                        transition: all 0.6s;
                        transform: translate3d(0,100px,0);
                        opacity: 0;
                        .list-title{
                            font-size: 30px;
                            color: #F88927;
                            text-align: center;
                            margin-bottom: 20px;
                        }
                        ul{
                            color: #656666;
                            font-size: 16px;
                            li{
                                margin-bottom: 20px;
                                &::before{
                                    width:15px;
                                    height:15px;
                                    background:rgba(248,137,39,1);
                                    transform: rotate(50deg);
                                    content: '';
                                    display: inline-block;
                                    margin-right: 10px;
                                }
                            }
                        }
                    }
                }
            }
        }
        .item2{
            background: url('../assets/img_cpys.png') no-repeat center center;
            height: 655px;
            .item2-wrapper{
                width: 1200px;
                margin: 0 auto;
                .item2-title{
                    font-size: 36px;
                    color: #fff;
                    text-align: center;
                    padding: 40px 0;
                }
                .list{
                    display: flex;
                    flex-wrap: wrap;
                    box-sizing: border-box;
                    li{
                        transition: all 0.6s;
                        transform: translate3d(0,100px,0);
                        opacity: 0;
                        width:400px;
                        height:219px;
                        margin-right: -1px;
                        margin-bottom: -1px;
                        background:rgba(83,175,250,1);
                        border:1px solid rgba(255,255,255,1);
                        padding: 30px 40px;
                        box-sizing: border-box;
                        &:nth-of-type(2){
                            transition-delay: 0.3s;
                        }
                        &:nth-of-type(3){
                            transition-delay: 0.6s;
                        }
                        &:nth-of-type(5){
                            transition-delay: 0.3s;
                        }
                        &:nth-of-type(6){
                            transition-delay: 0.6s;
                        }
                        >div{
                            &:nth-of-type(1){
                                font-size: 24px;
                                color: #fff;
                                margin-bottom: 20px;
                            }
                            &:nth-of-type(2){
                                font-size: 18px;
                                color: #fff;
                            }
                        }
                    }
                }
            }
        }
        .item3{
            .item3-content{
                .right{
                    img{
                        
                    }
                }
            }
        }
        
        .item5{
            width: 1200px;
            margin: 0 auto;
            padding: 100px 0;
            .title{
                font-size: 36px;
                text-align: center;
                margin-bottom: 60px;
            }
            .list{
                display: flex;
                flex-wrap: wrap;
                .item{
                    width: 167px;
                    height: 167px;
                    padding: 20px;
                    box-sizing: border-box;
                    background:rgba(255,255,255,1);
                    box-shadow:0px 4px 16px 0px rgba(158,158,158,0.4);
                    margin-right: 91px;
                    margin-bottom: 38px;
                    transition: all 0.6s;
                    &:nth-of-type(5n){
                        margin-right: 0;
                    }
                    &:hover{
                        transform: scale(1.1);
                    }
                    .img{
                        width: 100px;
                        height: 100px;
                        margin: 0 auto;
                        img{
                            width: 100%;
                            height: 100%;
                        }
                    }
                    p{
                        margin-top: 5px;
                        text-align: center;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                    }
                }
            }
        }
        .video-wrapper{
            position: fixed;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            background-color: rgba(0, 0, 0, 0.3);
            z-index: 9999;
            .video-content{
                position: absolute;
                top: 50%;
                left: 50%;
                width: 900px;
                transform: translate(-50%,-50%);
                .close{
                    text-align: right;
                    font-size: 50px;
                    color: #fff;
                    .el-icon-error{
                        cursor: pointer;
                    }
                }
                .video-player{
                    .vjs-big-play-button{
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                    }
                }
            }
        }
    }
</style>